// extracted by mini-css-extract-plugin
export default {"fileNameBtn":"fileNameBtn---am_YA","disabledFileName":"disabledFileName---OYGpD","downloadFile":"downloadFile---Vu8B8"};